import * as CreateAccount_en from './CreateAccount.en.js';
import * as CreateAccount_es from './CreateAccount.es.js';

const CreateAccountTuple = [
  { type: 'CreateAccount', language: 'en', object: CreateAccount_en.default },
  { type: 'CreateAccount', language: 'es', object: CreateAccount_es.default },
];

export default CreateAccountTuple;
